import { createSelector } from 'reselect';

import {
  getItemById,
  getOrgSettings,
  getDataFromState,
  getItemsFromState,
  getIsFetchingFromState,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';
import { sortByIndex } from '../../utils';

const combiner = (requests, contacts, requestSources, requestStatuses, requestLabels, users) =>
  (requestSources && requestStatuses && requestLabels && users) &&
  Object.keys(requests).map(key => Object.assign({}, {
    ...requests[key],
    contacts: requests[key].contacts.map(id => contacts[id]),
    source: requestSources[requests[key].source],
    status: requestStatuses[requests[key].status],
    labels: requests[key].labels.map(id => requestLabels[id]),
  }));

export const getRequestsWithContacts = createSelector(
  [
    getDataFromState('requests'),
    getItemsFromState('contacts'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
    getUsers,
  ],
  combiner,
);

export const getSpecificRequestsWithContacts = createSelector(
  [
    getDataFromStateAndProps('requests'),
    getItemsFromState('contacts'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
    getUsers],
  combiner,
);

export const getFullRequestById = createSelector(
  [
    getItemById('requests', 'requestId'),
    getItemsFromState('contacts'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
    getUsers,
  ],
  (request, contacts, requestSources, requestStatuses, requestLabels, users) => {
    if (request && contacts && requestSources && users) {
      return {
        ...request,
        source: requestSources[request.source],
        status: requestStatuses[request.status],
        labels: request.labels.map(id => requestLabels[id]),
        contacts: request.contacts.map(id => contacts[id]) || [],
      };
    }

    return {};
  },
);

export const getRequestContactsById = createSelector(
  [
    getItemById('requests', 'requestId'),
    getItemsFromState('contacts'),
  ],
  (request, contacts) => ({
    request,
    contacts: request && request.contacts && request.contacts.map(id => contacts[id]) || [],
  }),
);

// checks whether requests and all related items were loaded
export const isRequestLoading = createSelector(
  getIsFetchingFromState('requests'),
  getIsFetchingFromState('contacts'),
  getIsFetchingFromState('meetingNotes'),
  getIsFetchingFromState('comments'),
  getIsFetchingFromState('tasks'),
  (...results) => results.some(isLoading => isLoading === true),
);

export const getRequestSettings = createSelector(
  [
    getOrgSettings('requestLabels'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
  ],
  (requestLabels = {}, requestSources = {}, requestStatuses = {}) => ({
    requestLabels,
    requestSources,
    requestStatuses: sortByIndex(requestStatuses),
  }),
);



// WEBPACK FOOTER //
// ./src/redux/selectors/requests.js